import { h, Component } from 'preact';

export default class AvailableSessions extends Component {
  state = {
    jsDate: new Date,
    sessions: [],
    dateObj: {}
  };

  componentWillMount() {
    this.fetchSessions();
  }

  componentDidUpdate(props, { jsDate }) {
    if (jsDate !== this.state.jsDate) {
      this.fetchSessions();
    }
  }

  onClickNextDate = (e) => {
    e.preventDefault();
    const { jsDate } = this.state;
    const newJsDate = new Date();
    newJsDate.setDate(jsDate.getDate() + 1);
    this.setState({ jsDate: newJsDate });
  }

  onClickPrevDate = (e) => {
    e.preventDefault();
    const { jsDate } = this.state;
    const newJsDate = new Date();
    newJsDate.setDate(jsDate.getDate() - 1);
    this.setState({ jsDate: newJsDate });
  }

  fetchSessions() {
    this.setState({
      dateObj: {},
      sessions: [],
      isLoading: true
    });
    return fetch(`${API_HOST}/sessions/${+this.state.jsDate}/available`)
      .then((r) => r.json())
      .then((json) => {
        this.setState({
          sessions: json.sessions,
          dateObj: json.date,
          isLoading: false
        });
      });
  }

  render() {
    return (
      <section class="available-sessions">
        <h3><span class="fa fa-calendar">&nbsp;</span> Book a Session</h3>
        <div>
          <p>To book a session, please contact Shaked Rosenthal:</p>
          <p><a class="underline" href="/contact">Via Contact Form</a></p>
          <p>Call/Text: (719) 271-7670</p>
        </div>
      </section>
    );
  }

  _render({}, { dateObj, sessions, isLoading }) {
    return (
      <section class="available-sessions">
        <h3><span class="fa fa-calendar">&nbsp;</span> Book a Session</h3>
        <div>
          {
            isLoading
              ? <h3>Loading ...</h3>
              : (
                <h3 class="flex flex-wrap flex-middle flex-center">
                  Available Sessions for
                  &nbsp;
                  <mark>
                    <a href="#" onClick={this.onClickPrevDate}>
                      <span class="fa fa-chevron-circle-left"></span>
                    </a>
                    &nbsp;
                    {dateObj.date}
                    &nbsp;
                    <a href="#" onClick={this.onClickNextDate}>
                      <span class="fa fa-chevron-circle-right"></span>
                    </a>
                  </mark>
                </h3>
              )
          }
          { sessions.map((s) =>
            <AvailableSession start={s.start} end={s.end} trainer="Shaked" location="Seattle" />
          ) }
        </div>
      </section>
    );
  }
}

class AvailableSession extends Component {
  render({ start, end, trainer, location }) {
    return (
      <article class="available-session flex flex-wrap flex-middle">
        <div>
          <span class="fa fa-clock-o">&nbsp;</span>
          {start.time} - {end.time}
        </div>
        <div>
          <span class="fa fa-male">&nbsp;</span>
          {trainer}
        </div>
        <div>
          <span class="fa fa-globe">&nbsp;</span>
          {location}
        </div>
        <div>
          <a href={`/book/${start.stamp}`} class="btn">
            <span class="fa fa-check">&nbsp;</span>
            Book
          </a>
        </div>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./components/available-sessions.js